import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import AttendeeProfileAvatarProps from './attendeeProfileAvatarProps';
import AvatarComponent from './avatar';
import FormattedPhone from '../text/formattedPhone';

interface AttendeeProfileAvatarState {
    isModalOpen: boolean;
}

class AttendeeProfileAvatar extends ObservingComponent<AttendeeProfileAvatarProps, AttendeeProfileAvatarState> {

    constructor(props: AttendeeProfileAvatarProps) {
        super(props);
        this.state = { isModalOpen: false };
    }

    public componentWillMount(): void {
        if (this.props.avatar) {
            this.registerUpdateObserver(this.props.avatar.observationProvider);
        }
    }

    public openModal = (e?: Event) => {
        if (e) e.stopPropagation();
        this.setState({ isModalOpen: true });
    }

    private closeModal = (e: Event) => {
        e.stopPropagation();
        this.setState({ isModalOpen: false });
    }

    private stopPropagation = (e: Event) => {
        e.stopPropagation();
    }

    public render({ avatar, attendee, canEditAttendees, className }: AttendeeProfileAvatarProps): JSX.Element {
        const { isModalOpen } = this.state;
        const profileImageUrl = avatar ? avatar.profileImageUrl : null;

        return (
            <div class="v-center">
                <a
                    class={`btn button inline-flex v-center btn-xl btn-secondary btn-icon ${className || ''}`}
                    onClick={this.openModal}>
                    <span class="btn-content">
                        <AvatarComponent
                            className="attendee-avatar"
                            url={profileImageUrl} />
                    </span>
                </a>

                {isModalOpen && (
                    <div class="modal-container" onClick={this.closeModal}>
                        <div class="attendee-profile-modal" onClick={this.stopPropagation}>
                            <button
                                type="button"
                                class="attendee-profile-modal-close"
                                onClick={this.closeModal}>
                                &times;
                            </button>
                            <div class="attendee-profile-modal-left">
                                {profileImageUrl
                                    ? <img src={profileImageUrl} class="attendee-profile-modal-image" />
                                    : <i class="ti ti-user-alt attendee-profile-modal-icon" />
                                }
                                <div class="attendee-profile-modal-name">{attendee.fullName}</div>
                                {attendee.isExecutive &&
                                    <div class="attendee-profile-modal-badge">IS EXECUTIVE</div>
                                }
                            </div>
                            <div class="attendee-profile-modal-right">
                                {attendee.title &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Title</div>
                                        <div class="attendee-profile-modal-info-value">{attendee.title}</div>
                                    </div>
                                }
                                {(attendee.businessArea || attendee.department) &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Business Area / Operating Company</div>
                                        <div class="attendee-profile-modal-info-value">
                                            {attendee.businessArea}
                                            {attendee.businessArea && attendee.department ? ' - ' : ''}
                                            {attendee.department}
                                        </div>
                                    </div>
                                }
                                {attendee.areaOfExpertise &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Area of Expertise</div>
                                        <div class="attendee-profile-modal-info-value">{attendee.areaOfExpertise}</div>
                                    </div>
                                }
                                {attendee.lineOfBusiness &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Line of Business</div>
                                        <div class="attendee-profile-modal-info-value">{attendee.lineOfBusiness}</div>
                                    </div>
                                }
                                {attendee.email &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Email</div>
                                        <div class="attendee-profile-modal-info-value">{attendee.email}</div>
                                    </div>
                                }
                                {attendee.contactPhone &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Mobile Phone</div>
                                        <div class="attendee-profile-modal-info-value">
                                            <FormattedPhone phone={attendee.contactPhone} />
                                        </div>
                                    </div>
                                }
                                {canEditAttendees &&
                                    <div class="attendee-profile-modal-info-row">
                                        <div class="attendee-profile-modal-info-label">Access Level</div>
                                        <div class="attendee-profile-modal-info-value">
                                            {attendee.isEventProducer ? 'Event Producer' : (attendee.eventAttendeeAccessLevel || 'Unknown')}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="modal-background" />
                    </div>
                )}
            </div>
        );
    }
}

export default AttendeeProfileAvatar;
